export const extractFileName = (response) =>
  response?.headers
    ?.get('Content-Disposition')
    ?.split('filename=')?.[1]
    ?.trim()
    ?.replace(/"/g, '');
